module.exports = __webpack_public_path__ + "static/media/CostOpportunity_Diagram_Desktop_SV.5c637133.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CostOpportunity_Diagram_Desktop_SV.png
// module id = 570
// module chunks = 0